import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  CreditCardOutlined,
  RollbackOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import PermissionTabsLayout, {
  PermissionTabsRedirect,
} from "../components/PermissionTabsLayout.jsx";
import useIsMobile from "../hooks/useIsMobile";

// Exporté pour alimenter la feuille « Aller à… » de l'écran Achats mobile.
export const PURCHASE_TABS = [
  {
    key: "achat",
    label: "Achat",
    icon: <ShoppingCartOutlined />,
    path: "/gestion-achats/achat",
    permission: "Gestion Commerciale.Approvisionnement.Achats.Achat.view",
  },
  {
    key: "bon-commande",
    label: "Bon de commande",
    icon: <SolutionOutlined />,
    path: "/gestion-achats/bon-commande",
    permission:
      "Gestion Commerciale.Approvisionnement.Achats.BonCommande.view",
  },
  {
    key: "retour-achat",
    label: "Retour d'achat",
    icon: <RollbackOutlined />,
    path: "/gestion-achats/retour-achat",
    permission:
      "Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view",
  },
  {
    key: "paiements-sortants",
    label: "Paiements sortants",
    icon: <CreditCardOutlined />,
    path: "/gestion-achats/paiements-sortants",
    permission:
      "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view",
  },
];

export const PurchaseTabsRedirect = () => (
  <PermissionTabsRedirect tabs={PURCHASE_TABS} />
);

// Les 4 onglets sont refondus en mobile : leur écran .epm est déjà haut de
// 100dvh − tabbar, la barre d'onglets AntD le pousserait hors du viewport. Chaque écran
// fournit sa propre navigation (feuille « Aller à… »).
const MOBILE_SHELL_ROUTES =
  /^\/gestion-achats\/(achat|bon-commande|retour-achat|paiements-sortants)/;

const PurchaseTabsLayout = () => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  if (isMobile && MOBILE_SHELL_ROUTES.test(pathname)) {
    return <Outlet />;
  }

  return <PermissionTabsLayout tabs={PURCHASE_TABS} />;
};

export default PurchaseTabsLayout;
